import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImageCropperV2Component} from './image-cropper-v2.component';
import {FileConversionService} from '../../global-services/file-conversion.service';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        ImageCropperV2Component,
    ],
    exports: [
        ImageCropperV2Component,
    ],
    providers: [
        FileConversionService
    ]
})
export class ImageCropperV2Module { }
